//NEW: UI_REVAMP
import { Box, Flex } from '@chakra-ui/react';
import { ReactComponent as BetOneIcon } from '../../assets/svg/bet-one.svg';
import { ReactComponent as BetThreeIcon } from '../../assets/svg/bet-three.svg';
import { ReactComponent as BetTwoIcon } from '../../assets/svg/bet-two.svg';
import { useBottomSheetStore } from '../../hooks/useBottomSheetStore';
import ImgComp from '../../utils/ImgComp';
import GradientBox from '../box/GradientBox';
import Header from '../Header/Header';
import ServerTime from '../Header/ServerTime';
import OptionTabList from '../tabs/OptionTabList';
import SiteOptionTab from './SiteOptionTab';

export const BETTING_TABS = {
	bet1: { label: 'Bet 1', value: 'bet1', icon: BetOneIcon },
	bet2: { label: 'Bet 2', value: 'bet2', icon: BetTwoIcon },
	bet3: { label: 'Bet 3', value: 'bet3', icon: BetThreeIcon },
};

const BettingPanel = ({
	activeBetTab,
	setActiveBetTab,
	activeSiteType,
	setActiveSiteType,
	getDraw,
	getGame,
	time,
	setTime,
	timeBtnId,
	setTimeBtnId,
	timeName,
	setTimeName,
	serverTime,
	activeBetType,
	setActiveBetType,
	handleLucky,
	handleEz2Add,
	showBetList,
	setShowBetList,
}) => {
	const activeSheet = useBottomSheetStore((s) => s.activeSheet);
	const isBottomSheetOpen = activeSheet !== null;
	return (
		<GradientBox
			p={{ base: 0, lg: 0.5 }}
			borderRadius={{ base: 'none', lg: '23px 8px 8px 8px' }}
			bgGradient={
				isBottomSheetOpen
					? ''
					: 'linear-gradient(180deg, #F5D7A9 0%, #E28E10 10.42%, #E3CA89 25%, #E2A74C 69.79%, #4D3A1A 85.42%, #F5D7A9 100%)'
			}
			boxShadow={isBottomSheetOpen ? '' : '0 4px 10px rgba(46, 124, 230, 0.3)'}
		>
			<Box position='absolute' zIndex={10} top={0} right={0} left={0}>
				<Header />
			</Box>
			<Box
				display='flex'
				flexDirection='column'
				gap='4px'
				bg={isBottomSheetOpen ? '' : 'rgba(135, 116, 254, 1)'}
				pt={{ base: '4px', lg: '0px' }}
				pb='4px'
				borderRadius={{ base: 'none', lg: '23px 8px 8px 8px' }}
			>
				{/* Mobile Info Row */}
				<Flex
					display={{ base: 'flex', lg: 'none' }}
					alignItems='center'
					justifyContent={isBottomSheetOpen ? 'start' : 'end'}
					mx='8px'
				>
					<Flex alignItems='center' gap='2px' w='145px'>
						<ImgComp svgName='alarm' w={3} h={3} />
						<ServerTime color={isBottomSheetOpen ? 'black' : 'white'} />
					</Flex>
				</Flex>

				{/* Betting Option Selection */}
				<OptionTabList
					gap={2}
					mx='8px'
					mt={{ base: 0, lg: 'calc(48px + 4px)' }}
					options={Object.values(BETTING_TABS)}
					activeValue={activeBetTab}
					onChange={setActiveBetTab}
				>
					{(item, _isActive, color) => (
						<>
							{item.icon && <item.icon color={color} width='20px' height='20px' />}
							{item.label}
						</>
					)}
				</OptionTabList>

				{/* Site Type Selection */}
				<SiteOptionTab
					activeSiteType={activeSiteType}
					setActiveSiteType={setActiveSiteType}
					getDraw={getDraw}
					getGame={getGame}
					time={time}
					setTime={setTime}
					timeBtnId={timeBtnId}
					setTimeBtnId={setTimeBtnId}
					timeName={timeName}
					setTimeName={setTimeName}
					serverTime={serverTime}
					activeBetType={activeBetType}
					setActiveBetType={setActiveBetType}
					handleLucky={handleLucky}
					handleEz2Add={handleEz2Add}
					showBetList={showBetList}
					setShowBetList={setShowBetList}
				/>
			</Box>
		</GradientBox>
	);
};

export default BettingPanel;
